export function categoryAccepted(rawConsent, categoryName) {
  if (!rawConsent) {
    return false
  }

  if (rawConsent.categories && rawConsent.categories[categoryName]) {
    return true
  }

  return Array.isArray(rawConsent.accepted) && rawConsent.accepted.includes(categoryName)
}
